export default {
  setTimeslot (state, timeslot) {
    state.timeslot = timeslot
  }
}
